export default __webpack_public_path__ + "static/media/doctorsedge.f6814362.png";